import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { updateTHStatus } from "../Redux/THSlice";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
 "& .MuiDialogContent-root": {
  padding: theme.spacing(2),
 },
 "& .MuiDialogActions-root": {
  padding: theme.spacing(1),
 },
}));
function BootstrapDialogTitle(props) {
 const { children, onClose, ...other } = props;

 return (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
   {children}
   {onClose ? (
    <IconButton
     aria-label="close"
     onClick={onClose}
     sx={{
      position: "absolute",
      right: 0,
      top: 0,
      color: (theme) => theme.palette.grey[500],
     }}
    >
     {/* <CloseIcon /> */}
     <img src="/images/Home/close_img.png" alt="icon" className="form_close_img" />
    </IconButton>
   ) : null}
  </DialogTitle>
 );
}

BootstrapDialogTitle.propTypes = {
 children: PropTypes.node,
 onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
 color: theme.palette.getContrastText("#7500C0"),
 backgroundColor: "#7500C0",
 "&:hover": {
  backgroundColor: "#7500C0",
  color: "#fff",
 },
}));
function ConfirmPopup(props) {
 const dispatch = useDispatch();

 const handleClose = () => {
  props.setOpenConfirmPopup(false);
 };
 const handleSubmit = async () => {
    try{
    dispatch(updateTHStatus(props.courseCode, props.startDate, props.clickedID, 4));
    props.setOpenConfirmPopup(false);
    }catch(err){
        console.log('err', err)
    }
 };

 return (
  <div>
   <BootstrapDialog
    onClose={handleClose}
    aria-labelledby="customized-dialog-title"
    open={props.openConfirmPopup}
   >
    <BootstrapDialogTitle
     id="customized-dialog-title"
     className="popup"
     sx={{
      fontSize: "16px",
      fontWeight: "600",
      textAlign: "center",
      paddingBottom: "0px !important",
     }}
     onClose={handleClose}
    ></BootstrapDialogTitle>
    <DialogContent sx={{ paddingTop: "15px", width: "600px" }}>
     <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
      <Typography sx={{ fontSize: "14px" }}>
       Number of participants scheduled has exceeded total seats available. Do you want to
       continue the submission?
      </Typography>
     </Stack>

     {/* {newQuestion} */}
    </DialogContent>
    <DialogActions
     sx={{ justifyContent: "center", alignItems: "center", marginBottom: "10px" }}
    >
     <ColorButton
      variant="contained"
      className="save-button"
      size="small"
      sx={{ background: "#7500C0", color: "white" }}
      autoFocus
      onClick={handleSubmit}
     >
      yes
     </ColorButton>
     <ColorButton
      variant="contained"
      className="cancel-button"
      size="small"
      sx={{ background: "white", color: "#7500C0", border: "solid 1px #7500C0" }}
      autoFocus
      onClick={handleClose}
     >
      No
     </ColorButton>
     {/* <Button autoFocus onClick={addMoreQuestion}>
      AddMore
     </Button> */}
    </DialogActions>
   </BootstrapDialog>
  </div>
 );
}

export default ConfirmPopup;
